import { notification } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  createGoldenPrompt,
  deleteGoldenPrompt,
  listGoldenPrompts,
} from './goldenPromptsApi'
import { GoldenPromptCreate } from './goldenPromptsModel'

const goldenPromptsKey = (userId: string | undefined) => ['goldenPrompts', userId] as const

export const useGoldenPromptsQuery = (userId: string | undefined) => {
  return useQuery({
    queryKey: goldenPromptsKey(userId),
    queryFn: () => listGoldenPrompts(userId!),
    enabled: !!userId,
    retry: false,
    onError: () => {
      notification.error({ message: 'Failed to load golden prompts' })
    },
  })
}

export const useCreateGoldenPromptMutation = (userId: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation((input: GoldenPromptCreate) => createGoldenPrompt(input), {
    onSuccess: () => {
      queryClient.invalidateQueries(goldenPromptsKey(userId))
    },
    onError: () => {
      notification.error({ message: 'Failed to mark prompt as golden' })
    },
  })
}

export const useDeleteGoldenPromptMutation = (userId: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation((promptId: string) => deleteGoldenPrompt(promptId), {
    onSuccess: () => {
      queryClient.invalidateQueries(goldenPromptsKey(userId))
    },
    onError: () => {
      notification.error({ message: 'Failed to remove golden prompt' })
    },
  })
}
